import { render, staticRenderFns } from "./studentsByModality.vue?vue&type=template&id=3725f128&"
import script from "./studentsByModality.js?vue&type=script&lang=js&"
export * from "./studentsByModality.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports